export class WorkSpaceRefreshToken {
  private readonly _refreshToken: string | null;

  constructor(props: { refreshToken: string }) {
    this._refreshToken = props.refreshToken;
  }

  get refreshToken(): string | null {
    if (!this._refreshToken || this._refreshToken === "") {
      return null;
    }
    return this._refreshToken;
  }
}
